import "./MaintenanceCallout.scss";

export default {
  root: "im-maintenance-callout",
  message: "im-maintenance-callout__message",
  warning: "im-maintenance-callout--warning",
  error: "im-maintenance-callout--error",
  success: "im-maintenance-callout--success",
  info: "im-maintenance-callout--info",
};
